module.exports = __webpack_public_path__ + "js/2.2fd28e80.worker.js"